import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Typography, Stack} from 'views/components';
import {Accordion, AccordionDetails, AccordionSummary} from 'views/components';
import {Translate} from 'views/module';

import ClientContacts from './client_contact/ClientContacts';

const ClientSettings = (props) => {
  const clientRn = props.clientRn;
  const clientData = props.clientData;
  const clientBackend = props.clientBackend;

  const view = props.clientSettingsView;
  const setView = props.setClientSettingsView;

  const handleChange = (panel) => (event, isExpanded) => {
    setView(isExpanded ? panel : '');
  };

  return (
    <Stack
      spacing={2}
      sx={{
        mr: 2,
      }}
    >
      <Accordion
        expanded={view === 'CONTACT'}
        onChange={handleChange('CONTACT')}
        sx={{marginBottom: '16px'}}
        TransitionProps={{unmountOnExit: true}}
        disableGutters
      >
        <AccordionSummary
          sx={{
            'flexDirection': 'row-reverse',
            '& .MuiAccordionSummary-content': {
              marginLeft: '8px',
            },
            '&.Mui-expanded': {
              minHeight: '0px',
            },
            'borderBottom': '1px solid rgba(0, 0, 0, 0.12)',
            'textTransform': 'uppercase',
          }}
        >
          <Typography sx={{textTransform: 'uppercase', fontWeight: 500, color: 'black'}}>
            <Translate expression='client.ClientDetail.Settings.Contact.Title'/>
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            paddingTop: '8px',
            paddingBottom: '0px',
            overflow: 'auto',
          }}
        >
          <ClientContacts
            clientRn={clientRn}
            clientData={clientData}
            clientBackend={clientBackend}
          />
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
};

ClientSettings.propTypes = {
  clientRn: PropTypes.string.isRequired,
  clientData: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
  clientSettingsView: PropTypes.string.isRequired,
  setClientSettingsView: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(ClientSettings));
